import { render, staticRenderFns } from "./moderate.vue?vue&type=template&id=5a8dbc22&scoped=true&"
import script from "./moderate.vue?vue&type=script&lang=ts&"
export * from "./moderate.vue?vue&type=script&lang=ts&"
import style0 from "./moderate.vue?vue&type=style&index=0&id=5a8dbc22&prod&lang=scss&"
import style1 from "./moderate.vue?vue&type=style&index=1&id=5a8dbc22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dbc22",
  null
  
)

export default component.exports